import { OperatingRegion } from '@xbcb/shared-types';

export type ConnectionStatusOperatingRegion = OperatingRegion.US;

export const channelConnectionEnabledRegions = [OperatingRegion.US];
